import { Box, styled } from '@planne-software/uni/mui/material';
import { accordionClasses } from '@planne-software/uni';
import { uni } from '@planne-software/uni/v2';

import { breakpoints } from '@src/common/breakpoints';
import { uniTypography } from '@src/fonts/typography/uniTypography';

export const MobileSummaryDetails = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-200'),
  width: '100%',
}));

export const MobileSummaryRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
  gap: uni('scale-400'),
}));

export const MobileSummaryRowLabel = styled('span')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-body')};
`;

export const MobileSummaryRowValue = styled('span')`
  ${uniTypography('text-sm', 'semibold')}
  color: ${uni('fg-neutral-static-default-body')};
  text-align: right;
`;

export const MobileSummaryRowMutedValue = styled('span')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-placeholder')};
  text-align: right;
`;

export const MobileSummaryCouponRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: uni('scale-100'),
  width: '100%',
}));

export const MobileSummaryCouponInfo = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-100'),
  alignItems: 'flex-start',
  flex: 1,
  minWidth: 0,

  ['& > button']: {
    alignSelf: 'flex-start',
  },
}));

export const MobileSummaryCouponCode = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${uni('scale-100')};
  min-width: 0;
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-caption')};

  & > span {
    min-width: 0;
    overflow-wrap: anywhere;
  }
`;

export const MobileSummaryServiceFeeLabel = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${uni('scale-100')};
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-body')};
`;

export const SummaryRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-400'),
  width: '100%',
}));

export const SummaryCardRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-400'),
  width: '100%',
  padding: uni('padding-content'),
  backgroundColor: uni('bg-static-content-default'),
  border: `1px solid ${uni('border-static-content-default')}`,
  borderRadius: uni('border-radius-md'),
}));

export const SummaryHeaderCard = styled(SummaryCardRoot)(() => ({
  gap: uni('scale-600'),
}));

export const SummaryHeaderTitleRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: uni('scale-400'),
  width: '100%',
}));

export const SummaryHeaderTitle = styled('h2')`
  ${uniTypography('text-lg', 'semibold')}
  color: ${uni('fg-neutral-static-default-heading')};
  margin: 0;
`;

export const SummaryHeaderProductCount = styled('span')`
  ${uniTypography('text-md', 'semibold')}
  color: ${uni('fg-neutral-static-default-caption')};
`;

export const SummarySection = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-400'),
  width: '100%',
}));

export const SummaryTotalRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: uni('scale-400'),
  width: '100%',
}));

export const SummaryTotalLabel = styled('span')`
  ${uniTypography('text-lg', 'semibold')}
  color: ${uni('fg-neutral-static-default-heading')};
`;

export const SummaryTotalValue = styled('span')`
  ${uniTypography('text-lg', 'semibold')}
  color: ${uni('fg-neutral-static-default-heading')};
`;

export const SummaryItemCardRoot = SummaryCardRoot;

export const SummaryItemCardInner = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-400'),
  width: '100%',
}));

export const SummaryPackageCardRoot = SummaryCardRoot;

export const SummaryItemCardHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: uni('spacing-24-16'),
  width: '100%',
}));

export const SummaryItemCardInfo = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: uni('scale-200'),
  flex: 1,
  minWidth: 0,
}));

export const SummaryItemCardTitle = styled('h3')`
  ${uniTypography('text-md', 'semibold')}
  color: ${uni('fg-neutral-static-default-heading')};
  margin: 0;
  width: 100%;
`;

export const SummaryItemCardImage = styled('img')`
  width: 6.5rem;
  height: 6.5rem;
  border-radius: ${uni('border-radius-xs')};
  object-fit: cover;
  flex-shrink: 0;

  @media (max-width: ${breakpoints.smallTablet}) {
    width: 4rem;
    height: 4rem;
  }
`;

export const SummaryItemMetaRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: uni('scale-200'),
}));

export const SummaryItemMetaText = styled('span')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-caption')};
  display: inline-flex;
  align-items: center;
  gap: ${uni('scale-100')};
`;

export const SummaryItemSellerRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: uni('scale-100'),
  width: '100%',
}));

export const SummaryItemSellerLabel = styled('span')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-body')};
`;

export const SummaryItemSellerInfo = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: uni('scale-100'),
}));

export const SummaryItemSellerAvatar = styled('img')`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: ${uni('border-radius-round')};
  border: 1px solid ${uni('border-neutral-subtle-rest')};
  object-fit: cover;
  flex-shrink: 0;
`;

export const SummaryItemSellerName = styled('span')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-body')};
`;

export const SummaryChargesSection = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const SummaryChargesTitle = styled('span')`
  ${uniTypography('text-md', 'semibold')}
  color: ${uni('fg-neutral-static-default-body')};
  display: inline-flex;
  align-items: center;
  gap: ${uni('scale-100')};
`;

export const SummaryChargesDetails = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  paddingLeft: uni('scale-200'),
  paddingTop: uni('scale-200'),
  paddingBottom: uni('scale-200'),
}));

export const SummaryChargesList = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-300'),
  width: '100%',
  paddingLeft: uni('scale-200'),
  borderLeft: `1px solid ${uni('border-neutral-subtle-rest')}`,
}));

export const SummaryChargeRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: uni('scale-600'),
  width: '100%',
}));

export const SummaryChargeName = styled('span')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-caption')};
  flex: 1 0 0;
  min-width: 0;
`;

export const SummaryChargePrices = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  flexShrink: 0,
  gap: uni('scale-100'),
}));

export const SummaryChargeOriginalPrice = styled('span')`
  ${uniTypography('text-xs', 'medium')}
  color: ${uni('fg-neutral-static-default-caption')};
  text-decoration: line-through;
  white-space: nowrap;
`;

export const SummaryChargePrice = styled('span')`
  ${uniTypography('text-sm', 'semibold')}
  color: ${uni('fg-neutral-static-default-body')};
  flex-shrink: 0;
  white-space: nowrap;
`;

export const SummaryItemFooter = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-200'),
  alignItems: 'flex-end',
  width: '100%',
}));

export const SummaryItemTotal = styled('span')`
  ${uniTypography('text-lg', 'semibold')}
  color: ${uni('fg-neutral-static-default-heading')};
`;

export const SummaryPackageAccordionTitle = styled('span')`
  ${uniTypography('text-md', 'semibold')}
  color: ${uni('fg-neutral-static-default-body')};
`;

export const SummaryPackageAccordionRoot = styled(Box)(() => ({
  width: '100%',

  [`& .${accordionClasses.root}`]: {
    margin: '0 !important',
    maxWidth: '100%',
    backgroundColor: 'transparent !important',
    boxShadow: 'none',

    '&:before': {
      display: 'none',
    },

    [`&.${accordionClasses.expanded}`]: {
      margin: '0 !important',
    },
  },

  [`& .${accordionClasses.heading} > button`]: {
    padding: `${uni('scale-200')} 0`,
    minHeight: 'unset !important',
    backgroundColor: 'transparent !important',

    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },

  [`& .${accordionClasses.showBorderBottom}`]: {
    borderBottom: `1px solid ${uni('bg-static-divider-default')} !important`,
  },
}));

export const SummaryPackageItemDivider = styled(Box)(() => ({
  width: '100%',
  height: '1px',
  backgroundColor: uni('bg-static-divider-default'),
  flexShrink: 0,
  margin: `${uni('scale-400')} 0`,
}));

export const SummaryPackageDetails = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  paddingTop: uni('scale-400'),
}));
